import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  EntityAreaApi,
  FilterEntityAreaOptions,
  FindEntityAreaForInheritQuery,
  SyncEntityArea,
} from 'api';

export const filterEntityArea = createAsyncThunk(
  'entityArea/filterEntityArea',
  async (option: FilterEntityAreaOptions, { rejectWithValue }) => {
    try {
      const response = await EntityAreaApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterEntityAreaForSelect = createAsyncThunk(
  'entityArea/filterEntityAreaForSelect',
  async (option: FilterEntityAreaOptions, { rejectWithValue }) => {
    try {
      const response = await EntityAreaApi.filterForSelect(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findInheritEntityArea = createAsyncThunk(
  'entityArea/findInheritEntityArea',
  async (params: FindEntityAreaForInheritQuery, { rejectWithValue }) => {
    try {
      const response = await EntityAreaApi.findInheritEntityArea(params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkExistEntityAreas = createAsyncThunk(
  'entityArea/checkExistEntityAreas',
  async (
    params: { entityIDs: string[]; entityAreaIDs: string[] },
    { rejectWithValue }
  ) => {
    const { entityIDs, entityAreaIDs } = params;

    try {
      const response = await EntityAreaApi.checkExistEntityAreas(
        entityIDs,
        entityAreaIDs
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const syncEntityAreasInChain = createAsyncThunk(
  'entityArea/syncEntityAreasInChain',
  async (body: SyncEntityArea, { rejectWithValue }) => {
    try {
      const response = await EntityAreaApi.syncEntityAreasInChain(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityArea = createAsyncThunk(
  'entityArea/createEntityArea',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityAreaApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityArea = createAsyncThunk(
  'entityArea/findOneEntityArea',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityAreaApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityArea = createAsyncThunk(
  'entityArea/updateEntityArea',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityAreaApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const closeReuseDiaryArea = createAsyncThunk(
  'entityArea/closeReuseDiaryArea',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityAreaApi.closeReuseDiary(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityArea = createAsyncThunk(
  'entityArea/removeEntityArea',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityAreaApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  query: {},
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const entityAreaSlice = createSlice({
  name: 'entityArea',
  initialState,
  reducers: {
    reloadEntityArea(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityArea(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityArea(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(filterEntityAreaForSelect.fulfilled, (state, action) => {
      const { data } = action.payload;

      if (data) {
        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.list = newData;
      }
    });
  },
});

const { actions, reducer: entityAreaReducer } = entityAreaSlice;

export const {
  reloadEntityArea,
  updateSavedPaginationEntityArea,
  updateSavedListEntityArea,
} = actions;

export default entityAreaReducer;
